var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-alert-banner',{attrs:{"title":_vm.$t('app.new_carrier_platform_banner.title'),"variant":"info"}},[_c('p',{staticClass:"tw-mb-0"},[_vm._v(" "+_vm._s(_vm.$t('app.new_carrier_platform_banner.paragraph'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }